import { render, staticRenderFns } from "./FattureInCloudPanel.vue?vue&type=template&id=8b81f886&scoped=true"
import script from "./FattureInCloudPanel.vue?vue&type=script&lang=js"
export * from "./FattureInCloudPanel.vue?vue&type=script&lang=js"
import style0 from "./FattureInCloudPanel.vue?vue&type=style&index=0&id=8b81f886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b81f886",
  null
  
)

export default component.exports